import {
  makePaymentModalFooterElem,
  makePaymentModalDisplaySelectElem,
  makePaymentModalDisplayPayElem
} from './constants'
import paymentModalTitle from './title'

export default function paymentModalIframeDisplay(showIframe = true) {
  if (showIframe) {
    const makePaymentFspayUrlData = makePaymentModalFooterElem.attr('data-payment-url')
    const makePaymentDisplayPayHeaderTitleData = makePaymentModalDisplayPayElem.attr('data-header-title')

    paymentModalTitle(makePaymentDisplayPayHeaderTitleData)
    makePaymentModalDisplayPayElem.find('iframe').attr('src', makePaymentFspayUrlData)
    makePaymentModalDisplayPayElem.removeClass('hide')
    makePaymentModalDisplaySelectElem.addClass('hide')
  } else {
    paymentModalTitle()
    makePaymentModalDisplayPayElem.addClass('hide')
    makePaymentModalDisplaySelectElem.removeClass('hide')
  }
}
